import React, { useEffect, useState } from "react";
import { Icon, Tooltip } from "@plum-xoxo/admin-dsm";
import { app_path } from "config";
import { useHistory, useLocation } from "react-router-dom";
import OptionSideBar from "./OptionSideBar";
import theme from "../../theme";
import { ACL_MODULE_MAPPING } from "../../constants/RouteConstant";
import { getDefaultRoute } from "../../utils/globals";

const SideBar = (props) => {
  const { moduleAcl, kyb_status, isFirstRewardSent, plumGifting } = props;
  const dismissKyb = JSON.parse(sessionStorage.getItem("dismissKyb")) || false;
  const history = useHistory();
  const location = useLocation();

  let moduleAclArray = moduleAcl?.map((item) => item?.module_id);

  const [selectedSidebar, setSelectedSidebar] = useState(
    history.location.pathname
  );

  let link = getDefaultRoute(moduleAclArray, 2);
  if (
    link === "dashboard" &&
    moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO)
  ) {
    link = "generate-brand-voucher";
  }

  let plumGiftingUrls = [];
  plumGifting?.forEach((gifting) => {
    gifting?.items?.forEach((item) => {
      plumGiftingUrls.push(`gifting/${item?._id}`);
    });
  });

  const sidebarOptions = [
    {
      name: "Send Rewards",
      icon: "PlumGift",
      url: [
        link,
        "xoxo-points",
        "xoxo-code",
        "xoxo-link",
        "generate-brand-voucher",
        ...plumGiftingUrls,
      ],
      show:
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO),
    },
    {
      name: "Reports",
      icon: "PlumReport",
      url: [
        "reports",
        "reports/xoxo-token-report",
        "reports/voucher-recharge",
        "reports/plum-pro-report",
        "reports/empuls-report",
        "reports/perks-report",
      ],
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON),
    },
    {
      name: "Payments",
      icon: "PlumWallet",
      url: [
        "recharge#wallet-balance",
        "recharge",
        "recharge#transaction-history",
      ],
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.RECHARGE),
    },
    {
      name: "Integrations",
      icon: "PlumIntegration",
      url: ["integration-dashboard/manage-integration"],
      show: true,
    },
    {
      name: "Settings",
      icon: "PlumSetting",
      url: [
        "accounts/platform-preferences#account",
        "accounts/platform-preferences",
      ],
      show: true,
    },
  ];

  useEffect(() => {
    const newPath = history.location.pathname + history.location.hash;
    setSelectedSidebar(newPath.replace(/\/$/, ""));
  }, [history.location.pathname, location.pathname]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 52px)",
          minWidth: "50px",
          zIndex: "-1",
        }}
      ></div>
      <div
        className="d-flex flex-column align-items-center fixed-top pt-24 cursor-pointer"
        style={{
          height: "100vh",
          minWidth: "52px",
          maxWidth: "52px",
          backgroundColor: theme.palette.common.white,
          gap: "12px",
          borderRight: `1px solid ${theme.palette.light.c300}`,
          marginTop:
            (!dismissKyb && !isFirstRewardSent) ||
            (props.accountReducer?.mfaData?.res?.length &&
              props.accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1) ||
            kyb_status === 6 ||
            kyb_status === 7
              ? "92px"
              : "52px",
        }}
      >
        {sidebarOptions.map((option, index) => {
          if (!option.show) return;
          const url = option.url.length ? option.url[0] : "";
          let formattedSelectedSidebar = selectedSidebar.replace(
            `/${app_path}/`,
            ""
          );

          return (
            <Tooltip
              offset={[10, 0]}
              placement="bottom"
              tooltip={option.name}
              key={index}
            >
              <div
                className="p-10 d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: option.url.includes(formattedSelectedSidebar)
                    ? theme.palette.yellow.c100
                    : "",
                  height: "40px",
                  width: "40px",
                  borderRadius: "4px",
                }}
                onClick={() => {
                  history.push(`/${app_path}/${url}`);
                  setSelectedSidebar(`/${app_path}/${url}`);
                }}
              >
                <Icon
                  color={
                    option.url.includes(formattedSelectedSidebar)
                      ? "primary"
                      : "dark"
                  }
                  shade={
                    option.url.includes(formattedSelectedSidebar)
                      ? "c03"
                      : "c300"
                  }
                  iconName={option.icon}
                  size={20}
                  className="d-inline-block"
                />
              </div>
            </Tooltip>
          );
        })}
      </div>
    </>
  );
};

export default SideBar;
